export default __webpack_public_path__ + "static/media/opening-1.740fa04e.jpg";